import React from "react";

function Card({ children, style = {}, className, onClick }) {
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        background: "#ffffff",
        border: "none",
        borderRadius: 12,
        padding: "20px 22px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default Card;
